import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = 'arkhrms.activeRole';

type StoredActiveRole = {
  userId: number;
  roleCode: string;
};

/** undefined: not loaded yet. null: loaded and empty. */
let cached: StoredActiveRole | null | undefined;

function normalize(roleCode: string): string {
  return roleCode.trim().toUpperCase();
}

export function rememberActiveRole(userId: number, roleCode: string): void {
  const normalized = normalize(roleCode);
  if (!userId || !normalized) return;
  cached = { userId, roleCode: normalized };
}

export async function saveActiveRole(userId: number, roleCode: string): Promise<void> {
  rememberActiveRole(userId, roleCode);
  if (!cached) return;
  await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(cached));
}

export async function clearActiveRole(): Promise<void> {
  cached = null;
  await AsyncStorage.removeItem(STORAGE_KEY);
}

/** Role code to send as X-Active-Role, or null when this device has not chosen one. */
export async function getActiveRoleCode(): Promise<string | null> {
  if (cached !== undefined) return cached?.roleCode ?? null;
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (!raw) {
      cached = null;
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<StoredActiveRole>;
    const roleCode = typeof parsed.roleCode === 'string' ? normalize(parsed.roleCode) : '';
    const userId = Number(parsed.userId);
    if (!roleCode || !Number.isInteger(userId) || userId <= 0) {
      cached = null;
      return null;
    }
    cached = { userId, roleCode };
    return roleCode;
  } catch {
    cached = null;
    return null;
  }
}
